function Sizer() {
    this.build();
    resizeCallbacks.push(this);
}

Sizer.prototype.build = function () {
    const sizerLeft = $('[data-sizer-md-4-left]');
    const sizerRight = $('[data-sizer-md-4-right]');
    const targetsLeft = $('.sizer-target-md-4-left');
    const targetsRight = $('.sizer-target-md-4-right');
    const sizerContainerLeft = $('[data-sizer-container-md-4-left]');
    const targetsContainerLeft = $('.sizer-target-container-left');

    if  (sizerLeft.length && targetsLeft.length) {
        var computedWidthLeft = sizerLeft.offset().left + sizerLeft.innerWidth();

        targetsLeft.each(function(index, elem) {
            if (window.innerWidth > 767) {
                $(elem).css({
                    'width': computedWidthLeft,
                    'left': - sizerLeft.offset().left
                });
            } else {
                $(elem).css({'width': ''});
            }

            if (window.innerWidth > 1940) {
                $(elem).css({
                    'left': - sizerLeft.position().left
                });
            }
        });
    }

    if  (sizerRight.length && targetsRight.length) {
        var computedWidthRight = window.innerWidth - sizerRight.offset().left;

        targetsRight.each(function(index, elem) {
            if (window.innerWidth > 767) {
                $(elem).css({'width': computedWidthRight});
            } else {
                $(elem).css({'width': ''});
            }
        });
    }

    if  (sizerContainerLeft.length && targetsContainerLeft.length) {
        var computedContainerWidthLeft = sizerContainerLeft.offset().left + sizerContainerLeft.innerWidth();

        targetsContainerLeft.each(function(index, elem) {
            if (window.innerWidth > 767) {
                $(elem).css({'width': computedContainerWidthLeft});
            } else {
                $(elem).css({'width': ''});
            }
        });
    }
};


Sizer.prototype.resize = function () {
    this.build();
};
